import React, { useEffect, useState } from "react";

// Services
import { getTranslateByFullKey, getTranslateByKey } from "@/main/services/utils";

// Components
import Button from "@/main/components/shared/button/button";
import SecondaryButton from "@/main/components/shared/button/secondaryButton";

// Styles
import * as S from "./styles";

interface IModalSavePredefinedSearch {
	titleModal: string;
	open: boolean;
	handleModalCancel: () => void;
	handleModalConfirm: (description: string) => void;
	isLoading: boolean;
	idInput?: string;
}

function ModalSavePredefinedSearch({
	titleModal,
	open,
	handleModalCancel,
	handleModalConfirm,
	isLoading,
	idInput,
}: IModalSavePredefinedSearch) {
	const [description, setDescription] = useState("");
	const [errorMessage, setErrorMessage] = useState("");

	useEffect(() => {
		if (open) {
			setDescription("");
			setErrorMessage("");
		}
	}, [open]);

	function handleChange(event: React.ChangeEvent<HTMLInputElement>) {
		const value = event.target.value;

		if (value.length >= 40) {
			setErrorMessage(getTranslateByFullKey("e.nah.userPredefinedSearch.descriptionExceedsMaximumCharacters"));
			return;
		}

		setErrorMessage("");
		setDescription(value);
	}

	function onSave() {
		if (description.trim().length === 0) {
			setErrorMessage(getTranslateByFullKey("e.nah.information.descriptionNotInformed"));
			return;
		}

		handleModalConfirm(description);
	}

	if (!open) return null;
	return (
		<S.ModalOverlay>
			<S.BoxModal>
				{titleModal && <S.TitleModal>{titleModal}</S.TitleModal>}

				<S.ContainerInput>
					<S.InputWrapper>
						<S.InputText
							value={description}
							onChange={handleChange}
							placeholder={getTranslateByKey("information.userPredefinedSearchPlaceholder")}
							maxLength={40}
							id={idInput}
						/>
						<span className="required">*</span>
					</S.InputWrapper>

					{errorMessage && <S.ErrorLabel>{errorMessage}</S.ErrorLabel>}
				</S.ContainerInput>

				<S.ButtonsArea>
					<SecondaryButton type="button" onClick={handleModalCancel} disabled={isLoading}>
						{getTranslateByKey("information.cancel")}
					</SecondaryButton>

					<Button type="button" onClick={onSave} isLoading={isLoading}>
						{getTranslateByKey("information.save")}
					</Button>
				</S.ButtonsArea>
			</S.BoxModal>
		</S.ModalOverlay>
	);
}

export default ModalSavePredefinedSearch;
